import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const TimeSheetMissionService = {
    async findMissionsTimesheetByFilter(filter){
         try{
             const queryParams = new URLSearchParams({
            state: filter.state || "",
            reference: filter.reference || "",
            destination: filter.destination || "",
            debut: filter.debut || "",
            fin: filter.fin || "",
            title: filter.title || ""
          });

           const url = filter.state || filter.reference || filter.destination || filter.debut || filter.fin || filter.title
                ? `${apiUrl}/TimeSheetMission?${queryParams.toString()}`
                : `${apiUrl}/TimeSheetMission/`;
    
            const result = await axios.get(url);
            if (result) {
                return result.data;
            }
            } catch (err){
                if (err.response) {
                    return err.response.data;
                }
            }
    },

    async retrieveDestinationsTimesheet(mission_planning_id, mission_planning_agenda_id, mission_timesheet_id){
        try{
            const result = await axios.get(`${apiUrl}/TimeSheetMission/destinationsTimesheet/`, {
                params: {
                    mission_planning_id,
                    mission_planning_agenda_id,
                    mission_timesheet_id
                }
            });
            if (result) {
                return result.data;
            }
            } catch (err){
                if (err.response) {
                    return err.response.data;
                }
            }
    },
    async saveTimesheetMission(formValues){
        try{
            const result = await axios.post(`${apiUrl}/TimeSheetMission/`, formValues);
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async sendAndGenerate(mission_planning_id, mission_planning_agenda_id, mission_timesheet_id){
        try{
            const result = await axios.get(`${apiUrl}/TimeSheetMission/sendAndGenerate/`, {
                params: {
                    mission_planning_id,
                    mission_planning_agenda_id,
                    mission_timesheet_id
                }
            });
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async activateTimesheet(mission_timesheet_id, state){
        try{
            const result = await axios.get(`${apiUrl}/TimeSheetMission/activate/?mission_timesheet_id=${mission_timesheet_id}&mission_timesheet_state=${state}`);
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async downloadTimesheetFile(mission_planning_id, mission_planning_agenda_id, mission_timesheet_id){
        try{
            const result = await axios.get(`${apiUrl}/TimeSheetMission/download/?mission_planning_id=${mission_planning_id}&mission_planning_agenda_id=${mission_planning_agenda_id}&mission_timesheet_id=${mission_timesheet_id}`, {
                responseType: 'blob',
            });
            if (result) {
                return result.data;
            }
        }
        catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async retrieveDestinationsWithTransportTimesheet(mission_planning_id, mission_planning_agenda_id, mission_timesheet_id){
        try{
            const result = await axios.get(`${apiUrl}/TimeSheetMission/destinationsWithTransport/`, {
                params: {
                    mission_planning_id,
                    mission_planning_agenda_id,
                    mission_timesheet_id
                }
            });
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async validateTimesheetMission(mission_timesheet_id, mission_planning_id, mission_planning_agenda_id){
        try{
            const result = await axios.get(`${apiUrl}/TimeSheetMission/validate/?mission_timesheet_id=${mission_timesheet_id}&mission_planning_id=${mission_planning_id}&mission_planning_agenda_id=${mission_planning_agenda_id}`);
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async refuseTimesheetMission(mission_timesheet_id, observation, mission_planning_id, mission_planning_agenda_id){
        try{
            const result = await axios.post(`${apiUrl}/TimeSheetMission/refuse/`, {
                mission_timesheet_id,
                observation,
                mission_planning_id,
                mission_planning_agenda_id
            });
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async updateDestination(mission_destination_id, update_data){
        try{
            const result = await axios.put(`${apiUrl}/TimeSheetMission/updateDestination/`, {
                mission_destination_id,
                update_data
            }); 
            
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    }, 
    async getHistoryTimesheetMissions(mission_timesheet_id, filter){
        try{
            const queryParams = new URLSearchParams({
                user_name: filter.user_name || "",
                debut: filter.debut || "",
                fin: filter.fin || ""
            });
            const result = await axios.get(`${apiUrl}/TimeSheetMission/history?mission_timesheet_id=${mission_timesheet_id}&${queryParams.toString()}`, {
            });
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async addOrUpdateDestination(data){
        try{
            const result = await axios.post(`${apiUrl}/TimeSheetMission/addOrUpdateDestination/`, data);
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async shareTimesheetMission(data){
        try{
            const result = await axios.post(`${apiUrl}/TimeSheetMission/share/`, data);
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async getTimesheetData(mission_timesheet_id){
        try{
            const result = await axios.get(`${apiUrl}/TimeSheetMission/timesheet/?mission_timesheet_id=${mission_timesheet_id}`);
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
     async removeDestinationTimesheet(destinationId){
        try{
            const result = await axios.delete(`${apiUrl}/TimeSheetMission/removeDestinationTimesheet/` + destinationId);
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async deleteTimesheetByPlanningId(planningId){
        try{
            const result = await axios.delete(
                `${apiUrl}/TimeSheetMission/removeTimesheet/` + planningId,
                { data: { mission_planning_id: planningId } }
            );
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    }
}
export default TimeSheetMissionService;
